import { Outlet } from 'react-router-dom';

import { OnboardingProvider } from '@/contexts/OnboardingContext';

/**
 * Route layout that mounts :class:`OnboardingProvider` for the protected
 * subtree (both ``/onboarding`` and the funnel-guarded ``AppLayout`` routes
 * read the same context). Keeping the provider here — between
 * :class:`ProtectedRoute` and the page tree — means it never instantiates
 * on the public auth pages.
 */
export function OnboardingDataLayout() {
  return (
    <OnboardingProvider>
      <Outlet />
    </OnboardingProvider>
  );
}
